module.exports = __webpack_public_path__ + "static/img/avatar.94340873.png";